import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class TxnCurrencyFilter extends Component {
    state = {
        traCurrencyLists:[],
        traCurrencyValue: '',
        isTxnCurrLoading: true
    };
    componentDidMount(){
        this._get_txn_curr(this.props.start_date,this.props.end_date);
    }
//     resetCard()
//     {
//         this.setState({
//             cardTypeValue: [],
//         })
//     }
    _get_txn_curr(start_date, end_date){
        this.setState({
            traCurrencyLists:[],
            traCurrencyValue: [],
            isTxnCurrLoading: true
        })
        axios.post(config.get('API_URL')+'/reports/dcc-txncurrency/',{
                yestSend: start_date,
                todSend: end_date,
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
                this.setState({
                    traCurrencyLists:[]
                })
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((txn_currency, index) => {
                    this.state.traCurrencyLists.push({value: txn_currency.txn_currency, label: txn_currency.txn_currency})
                });
            }
            this.setState({
                isTxnCurrLoading: false
            })
        });

    }


    changeTraCurr(optionSelected){
        let value='';
        let traCurrArray = [];
        if(optionSelected.length < 1){
            value = null;
            traCurrArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                traCurrArray.push(mids.value)
                var index = this.state.traCurrencyLists.findIndex(obj => obj.value==mids.value);
                this.state.traCurrencyLists.move(index,0).join(',');
            });
        }

        this.props.onSelectTxnCurr(optionSelected, traCurrArray);
        this.setState({
            traCurrencyValue:optionSelected,
        });
    }
    render() {
        return (
            <ReactMultiSelectCheckboxes name="tra_curr"
                isMulti
                value={this.state.traCurrencyValue}
                styles={reactSelectStyles} className="report-listbox"
                isClearable={false}
                onChange={this.changeTraCurr.bind(this)}
                options={this.state.traCurrencyLists}
                placeholderButtonLabel="Select [Txn Currency]"
                isLoading={this.state.isTxnCurrLoading}
            />
        );

    }
}
export default TxnCurrencyFilter;